/**
 * @format
 */
import { Injectable } from "@angular/core";
import { createAction, props } from "@ngrx/store";

@Injectable()
export class TrackableItemsActions {
   static getItemCategory = createAction("[Trackable Items] Get ItemCategory", props<{ userId: number }>());

   static getItemCategorySuccess = createAction("[TrackableItems] Get ItemCategory Success", props<{ payload: any }>());

   static getItemCategoryFail = createAction("[TrackableItems] Get ItemCategory Fail", props<{ error: any }>());

   static getItemTypes = createAction("[Trackable Items] Get ItemType", props<{ userId: number }>());

   static getItemTypesSuccess = createAction("[TrackableItems] Get ItemType Success", props<{ payload: any }>());

   static getItemTypesFail = createAction("[TrackableItems] Get ItemType Fail", props<{ error: any }>());

   static getStates = createAction("[Trackable Items] Get States", props<{ userId: number }>());

   static getStatesSuccess = createAction("[TrackableItems] Get States Success", props<{ payload: any }>());

   static getStatesFail = createAction("[TrackableItems] Get States Fail", props<{ error: any }>());

   static getLocationTypes = createAction("[Trackable Items] Get LocationType", props<{ userId: number }>());

   static getLocationTypesSuccess = createAction(
      "[TrackableItems] Get LocationType Success",
      props<{ payload: any }>()
   );

   static getLocationTypesFail = createAction("[TrackableItems] Get LocationType Fail", props<{ error: any }>());

   static getLocations = createAction("[Trackable Items] Get Location", props<{ userId: number }>());

   static getLocationsSuccess = createAction("[TrackableItems] Get Location Success", props<{ payload: any }>());

   static getLocationsFail = createAction("[TrackableItems] Get Location Fail", props<{ error: any }>());
}
